import React from 'react';
import DefaultSlider from '@material-ui/core/Slider';
import { withStyles } from '@material-ui/core';
import Typography from '../Typography';

import { Colors } from '../../theme';

import { SliderProps } from './Slider.types';

const PrimarySlider = withStyles({
  root: {
    color: Colors.primary,
    height: 8,
    padding: '8px 0'
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: Colors.light,
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &:active': {
      boxShadow: 'inherit'
    },
    '&:after': {
      backgroundColor: 'currentColor',
      width: 10,
      height: 10,
      top: 5,
      left: 5
    }
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)'
  },
  track: {
    height: 8,
    borderRadius: 4
  },
  rail: {
    height: 8,
    borderRadius: 4,
    color: Colors.secondary,
    opacity: 1
  }
})(DefaultSlider);

const Slider: React.FC<SliderProps> = ({
  showStartEndLabel,
  startLabelText,
  endLabelText,
  className,
  ...others
}) => {
  return (
    <div className={className}>
      <PrimarySlider {...others} />
      {showStartEndLabel && (
        <div className="flex mt3">
          <Typography className="flex-1 grey" variant="Light100">
            {startLabelText}
          </Typography>
          <Typography className="flex-1 text-right grey" variant="Light100">
            {endLabelText}
          </Typography>
        </div>
      )}
    </div>
  );
};

Slider.defaultProps = {
  showStartEndLabel: false,
  startLabelText: '',
  endLabelText: '',
  className: '',
  step: 1,
  valueLabelDisplay: 'off'
};

export default Slider;
export { SliderProps };
